/* eslint-disable prettier/prettier */
import { Message } from "../Utils/Message";
export const Messages = {
    LOGIN_TITLE: new Message("LOGIN_TITLE", "Sign In"),
    LOGIN_INSTRUCTIONS: new Message("LOGIN_INSTRUCTIONS", "Sign in to access {0}"),
    SUBSCRIPTION_INSTRUCTIONS: new Message("SUBSCRIPTION_INSTRUCTIONS", "Select a subscription to continue"),
    LOGIN_BUTTON: new Message("LOGIN_BUTTON", "Continue"),
    LOGIN_PROMPT: new Message("LOGIN_PROMPT", "Email Address"),
    LOGIN_UNEXPECTED_ERROR: new Message("LOGIN_UNEXPECTED_ERROR", "Error when signing in. Check the browser console for more information."),
    LOGIN_UNAUTHORIZED_ERROR: new Message("LOGIN_UNAUTHORIZED_ERROR", "You are not authorized to access Aderant {0}. Please contact your system administrator."),
    LOGIN_INVALID_LOGIN_CREDENTIALS: new Message("LOGIN_INVALID_LOGIN_CREDENTIALS", "Your account or password is incorrect.")
};
